import SlsTracker from '@aliyun-sls/web-track-browser'
import { getEnv, isLocalEnv } from '@u/env'
import { useCommonStore } from '@/store/common'

// 初始化
export const initPubSub = () => {}

// 发送事件
export const pubSub_track_event = (data = {}) => {
  /* eslint-disable */
  return
  const commonStore = useCommonStore()
  const deviceInfo = commonStore.getDeviceInfo
  const {
    packageName,
    model,
    device,
    sdkVersionName,
    language,
    region,
    netType,
    device_name,
    pluginVersionCode = '',
    gaid = '',
    manufacturer = '',
  } = deviceInfo

  const params = {
    device,
    cashier_launch_pkg: packageName,
    model,
    device_name,
    iap_sdk_v: sdkVersionName,
    iap_v: pluginVersionCode,
    la: language,
    lo: region,
    network: netType,
    binding: 0, // h5内都为未绑定
    ...data,
    time: +new Date(),
    business: 'k3_oppo',
    gaid: gaid,
    manufacturer,
  }
  if (getEnv() === 'staging') {
    /* eslint-disable */
    console.log('===>打点参数', JSON.parse(JSON.stringify(params)))
  }
  if (!isLocalEnv) {
    pubsub('pub', JSON.stringify(params))
  }
  /* eslint-enable */
}

// export const pubSub_track = (eventName = '', options = {}) => {
//   pubSub_track_event({
//     action_type: eventName,
//     event_name: eventName,
//     ...options,
//   })
// }

const opts = {
  host: 'eu-central-1.log.aliyuncs.com', // 所在地域的服务入口。例如cn-hangzhou.log.aliyuncs.com
  project: 'logstoreh5', // Project名称。
  logstore: 'fe-pay-log', // Logstore名称。
  time: 10, // 发送日志的时间间隔，默认是10秒。
  count: 10, // 发送日志的数量大小，默认是10条。
  topic: 'topic', // 自定义日志主题。
  source: 'source',
  tags: {
    tags: 'tags',
  },
}

const pubSub_track = new SlsTracker(opts)

export default pubSub_track
